var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E7E8E3;}\n\t.st1{opacity:0.15;fill:#202121;enable-background:new    ;}\n\t.st2{fill:#E91E25;}\n\t.st3{fill:#F7A01D;}\n\t.st4{fill:#F26122;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M506.7,399.3c0,16.4-13.2,29.7-29.7,29.7H34.9c-16.4,0-29.7-13.3-29.7-29.7V112.7c0-16.4,13.3-29.6,29.7-29.6 h442.3c16.4,0,29.7,13.3,29.7,29.7L506.7,399.3L506.7,399.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.2,399.3V112.7C26.2,96.3,39.5,83,55.9,83h-21C18.5,83.1,5.2,96.3,5.2,112.7v286.6 c0,16.4,13.3,29.7,29.7,29.7h21C39.6,429,26.2,415.7,26.2,399.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.4,256c0-32.9,15.2-62.3,38.9-81.5c-18-14.6-41-23.4-66-23.4c-58,0-104.9,47-104.9,104.9 s46.9,104.9,104.9,104.9c25,0,48-8.8,66-23.4C238.5,318.3,223.4,288.9,223.4,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.4,151.1c-25,0-48,8.8-66,23.4c23.7,19.2,38.9,48.6,38.9,81.5s-15.2,62.3-38.9,81.5 c18,14.6,41,23.4,66,23.4c58,0,104.9-47,104.9-104.9S386.2,151.1,328.4,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.2,256c0-32.9-15.2-62.3-38.9-81.5c-23.7,19.2-38.9,48.6-38.9,81.5c0,32.9,15.2,62.3,38.9,81.5 C286,318.3,301.2,288.9,301.2,256z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.acdce34de13be05efd724f57ebfc89a7.svg";
export { ForwardRef as ReactComponent };